import React, { ReactNode } from "react";

import Box from "veneer/Box";
import styled from "veneer/styled";
import { Colors } from "veneer/Theme";

import LoadingIndicator from "cortex/ui/src/ui/loader/LoadingIndicator";

interface BasicLoaderProps {
  children?: ReactNode;
}

const CenteredBox = styled(Box)({
  left: "50%",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
});

export default function NavLoader({
  children = "Loading...",
}: BasicLoaderProps) {
  return (
    <CenteredBox bgcolor={Colors.white} borderRadius={2} p={4} width={400}>
      <LoadingIndicator title={String(children)} width={"100%"} />
    </CenteredBox>
  );
}
